<template>
  <div
    class="mb-2 flex items-center gap-2 rounded border border-blue-100/50 bg-refonte-pale-violet-2 px-4 py-3 text-sm text-blue-800">
    <span class="info-icon shrink-0">
      <IconInformation />
    </span>
    <div>
      Le signataire recevra d'abord un
      <strong>email contenant un lien sécurisé</strong>, puis un
      <strong>code SMS</strong>
      unique sera nécessaire pour authentifier sa signature et valider le
      document.
    </div>
  </div>
</template>

<script setup lang="ts">
  import IconInformation from '@/assets/img/refonte/icons/information/icon-information.svg?component';
</script>

<style lang="scss" scoped>
  .info-icon {
    @apply mr-2 flex shrink-0 items-center justify-center;
    width: 16px;
    height: 16px;

    :deep(svg) {
      @apply text-refonte_blue-600;
      width: 16px;
      height: 16px;
    }
  }
</style>
